export enum PassiveParameterType {
  GaitParametersLeft = 'Gait Left',
  GaitParametersRight = 'Gait Right',
  AlarmPressure = 'Pressure',
  AlarmTemperature = 'Temperature',
  AlertFall = 'Fall',
}
